import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import { Router } from '@angular/router';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import {EMPTY, Subscription} from "rxjs";
import {tap} from "rxjs/internal/operators/tap";
import {SnackBarService} from "../../shared-components/snack-bar/snack-bar.service";
import {catchError} from "rxjs/internal/operators/catchError";

@Component({
  selector: 'app-broadcastings-broadcastings-breadcrumb-card',
  templateUrl: './broadcastings-broadcastings-breadcrumb-card.component.html',
  styleUrls: ['./broadcastings-broadcastings-breadcrumb-card.component.scss']
})
export class BroadcastingsBroadcastingsBreadcrumbCardComponent implements OnInit, OnDestroy {

  @Input() broadcastings;
  filterOpened: boolean;
  viewDisposition;

  forceBroadcastingUpdateSubscription: Subscription;

  constructor(private router: Router,
              private broadcastingsService: BroadcastingsService,
              private snackbarService: SnackBarService) {
      this.viewDisposition = 'grid';
    }

  ngOnInit() {
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.broadcastingsService.toggleBroadcastingsDisposition(viewDis);
  }

  public newBroadcasting() {
    this.router.navigate(['/broadcastings/broadcasting']);
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

  public search(event) {
    this.broadcastingsService.searchBroadcastings(event.target.value);
  }

  public forceBroadcastingUpdate() {
    this.forceBroadcastingUpdateSubscription = this.broadcastingsService.forceAllBroadcastingsUpdate().pipe(
      tap(o => this.snackbarService.open('broadcastings-page.snackbar messages.broadcasting force update success', 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.forceBroadcastingUpdateSubscription) { this.forceBroadcastingUpdateSubscription.unsubscribe(); }
  }

}
